import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "./datepicker.css"; // Import DatePicker CSS
import { fr } from "date-fns/locale"; // Import French locale if needed
import moment from "moment";
import TimeSelector from "./TimeSelector";
import { ApiUrl } from "../../config";

const DateSelector = ({ selectedCenter, selectedDate, onDateChange, onDisabledTimesChange }) => {
  const [disabledDates, setDisabledDates] = useState([]);
  const [disabledTimes, setDisabledTimes] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showAlertNoEmplExist, setShowAlertNoEmplExist] = useState(false);
  const [selectedTime, setSelectedTime] = useState(null);
  

  const today = new Date(); // Today's date

  // Fetch fully booked days when a center is selected
  useEffect(() => {
    const fetchFullyBookedDays = async () => {
      setIsLoading(true); // Begin loading
      setDisabledDates([]);
      setDisabledTimes({});
      try {
        if (selectedCenter && selectedCenter.value) {
          const response = await fetch(
            `${ApiUrl}fetchSchedules/${selectedCenter.value}`
          );

          if (!response.ok) {
            if (response.status === 404) {
              setShowAlertNoEmplExist(true);
              console.log("No Employee Found");
            }
            setIsLoading(false);
            return; // Exit early
          } else {
            setShowAlertNoEmplExist(false);
          }

          const data = await response.json();
          console.log(data.partialScheduleFully);

          // Parse and set fully booked dates
          const bookedDates = data.fullyBookedDays.map((day) => new Date(day));
          setDisabledDates(bookedDates);
          console.log(bookedDates)


          // Set partial schedules if available for the selected date
          if (data.partialScheduleFully && selectedDate) {
            const formattedDate = selectedDate.toLocaleDateString("en-CA");
            console.log("formattedDate: " + formattedDate);

            const times = data.partialScheduleFully[formattedDate] || {};
            setDisabledTimes(times);
            onDisabledTimesChange(times);
            console.log(times)
          }
        }
      } catch (error) {
        console.error("Error fetching schedules:", error);
      } finally {
        setIsLoading(false); // Ensure loading ends regardless of outcome
      }
    };

    fetchFullyBookedDays();
  }, [selectedCenter, selectedDate]);

  // Filter function to disable weekends (optional)
  const isWeekday = (date) => {
    const day = date.getDay();
    return day !== 0 && day !== 6; // Exclude Sunday (0) and Saturday (6)
  };


  return (
    <div className="date-selector">
      {isLoading && <p>Loading...</p>} {/* Display loading message */}
      {showAlertNoEmplExist && <p>No Employee Found for this Center</p>} {/* Show alert if no employee exists */}

      <DatePicker
        dateFormat="MMMM d, yyyy"
        selected={selectedDate}
        onChange={onDateChange}
        inline={true}
        minDate={today}
        calendarClassName="custom-calendar-1"
        filterDate={isWeekday} 
        excludeDates={disabledDates}
        locale={fr} 
      />

    </div>
  );
};

export default DateSelector;
